import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ColumnSortIconComponent } from '../../shared/column-sort-icon/column-sort-icon.component';
import { TitleCasePipe } from '@angular/common';

@Component({
    selector: 'rn-channel-list-headings',
    templateUrl: './channel-list-headings.component.html',
    styleUrls: ['./channel-list-headings.component.scss'],
    standalone: true,
    imports: [ColumnSortIconComponent, TitleCasePipe]
})
export class ChannelListHeadingsComponent {
  /* 
    null can be passed in for a heading block with no title. 
    Used to maintain consistency in flexbox table layouts.
  */ 
  @Input() headings: (string | null)[];
  @Input() prefix: string;
  @Input() ordering: string;
  @Output() headingClicked: EventEmitter<string> = new EventEmitter();

  constructor() {}

  headingClick(heading): void {
    this.headingClicked.emit(heading);
  }

  isBlank(heading): boolean {
    return heading === null;
  }
}
